<template>
  <MondayWebforms :config="config" />
</template>

<script>
import MondayWebforms from "../../components/MondayWebforms/MondayWebforms.vue";

export default {
  name: "app",
  components: {
    MondayWebforms
  },
  data() {
    return {
		config: JSON.parse(this.$options._parentVnode.data.props.config)
	};
  }
};
</script>
